// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"35fccc03","455":"b7c1a242","977":"76704f73"}[chunkId] + ".chunk.js";
};